import React from 'react';
import { SiteFooter } from './FooterBarStyles';
import tmdbLogo from '../../imgs/svgs/tmdbLogo.svg';

const FooterBar = () => {
  return (
    <SiteFooter>
      <p>
        MOVIEPICKS Copyright {new Date().getFullYear()}. All rights reserved. |
        This product uses the TMDb API but is not endorsed or certified by TMDb.
      </p>

      <img src={tmdbLogo} alt='' />
    </SiteFooter>
  );
};

export default FooterBar;
